import { store } from "@/store/store";
import auth from "./middleware/auth";
export default [
  {
    path: "/learner",
    component: () => import("@/views/learner"),
    children: [
      {
        path: "course/:course_id/learn",
        component: () => import("@/views/learner/course/index"),
        children: [
          {
            path: "",
            name: "learner-home",
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "lesson/:lesson_id",
            name: "learner-lesson",
            component: () => import("@/views/learner/course/lesson"),
            meta: {
              middleware: [auth],
            },
            beforeEnter: (to, from, next) => {
              store.dispatch("fetchLearnerLesson", to.params.lesson_id);
              next();
            },
          },
        ],
      },
      {
        path: "cart",
        component: () => import("@/views/learner/cart"),
        children: [
          {
            path: "",
            name: "learner-cart",
            component: () => import("@/views/learner/cart/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "wishlist",
        component: () => import("@/views/learner/wishlist"),
        children: [
          {
            path: "",
            name: "learner-wishlist",
            component: () => import("@/views/learner/wishlist/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "discussion",
        component: () => import("@/views/learner/discussion/index"),
        children: [
          {
            path: "",
            name: "learner-discussion-home",
            component: () => import("@/views/learner/discussion/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "single/:id",
            name: "learner-discussion-single",
            component: () => import("@/views/learner/discussion/single"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "user/details/:user",
            name: "learner-discussion-user-details",
            component: () => import("@/views/learner/discussion/user"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "notification-settings",
        component: () => import("@/views/Shared/notification-settings"),
        children: [
          {
            path: "",
            name: "learner-notification-settings",
            component: () =>
              import("@/views/Shared/notification-settings/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "notes",
        component: () => import("@/views/learner/notes/index"),
        children: [
          {
            path: "",
            name: "learner-notes-home",
            component: () => import("@/views/learner/notes/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "single/:id",
            name: "learner-notes-single",
            component: () => import("@/views/learner/notes/single"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "growth_plan",
        component: () => import("@/views/learner/growthplan/index"),
        children: [
          {
            path: "",
            name: "learner-growthplan-home",
            component: () => import("@/views/learner/growthplan/plans"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "review",
            name: "learner-growthplan-review",
            component: () => import("@/views/learner/growthplan/review"),
            meta: {
              middleware: [auth],
            },
          },
          // {
          //   path: "course/:course_id",
          //   name: "learner-growthplan-plans",
          //   component: () => import("@/views/learner/growthplan/plans"),
          //   meta: {
          //     middleware: [auth],
          //   },
          // },
          {
            path: ":course_id/growth_plan/:id",
            name: "learner-growthplan-single",
            component: () => import("@/views/learner/growthplan/single"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "leaderboard",
        component: () => import("@/views/learner/leaderboard/index"),
        children: [
          {
            path: "",
            name: "learner-leaderboard-home",
            component: () => import("@/views/learner/leaderboard/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: ":id",
            name: "learner-leaderboard-single",
            component: () => import("@/views/learner/leaderboard/single"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "notifications",
        component: () => import("@/views/learner/notifications/index"),
        children: [
          {
            path: "",
            name: "learner-notifications-home",
            component: () => import("@/views/learner/notifications/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "submissions",
        component: () => import("@/views/learner/submissions/index"),
        children: [
          {
            path: "",
            name: "learner-submissions",
            component: () => import("@/views/learner/submissions/home"),
            props:true,
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "single/:id",
            name: "learner-single-submission",
            component: () => import("@/views/learner/submissions/single"),
          },
        ],
      },
      {
        path: "",
        name: "learner-home",
        component: () => import("@/views/learner/home"),
        meta: {
          middleware: [auth],
        },
      },
      // {
      //   path: "/learner/programs",
      //   name: "learner-programs",
      //   component: () => import("@/views/learner/program"),
      // },
      {
        path: "/learner/courses",
        name: "learner-courses",
        component: () => import("@/views/learner/course"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "my-courses",
        name: "learner-enrolled-courses",
        component: () => import("@/views/learner/my-courses"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "/learner/courses/:id",
        name: "learner-single-course",
        component: () => import("@/views/learner/course/single"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "/learner/programs/id",
        name: "learner-single-program",
        component: () => import("@/views/learner/single-program"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "/learner/courses/:id/modules",
        name: "learner-modules",
        component: () => import("@/views/learner/module"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "/learner/courses/:id/modules/:module",
        name: "learner-single-module",
        component: () => import("@/views/learner/single-module"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "/learner/courses/:id/modules/:module/lesson/:lesson",
        name: "learner-single-lesson",
        component: () => import("@/views/learner/single-lesson"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "/learner/settings",
        name: "learner-settings",
        component: () => import("@/views/learner/settings"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "/learner/completion",
        name: "learner-completion",
        component: () => import("@/views/learner/completion"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "programs",
        component: () => import("@/views/learner/programs/index"),
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "",
            name: "learner-programs",
            component: () => import("@/views/learner/programs/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "courses/:id",
            name: "learner-program-courses",
            component: () => import("@/views/learner/programs/course"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "certificate",
        component: () => import("@/views/learner/certificate/index"),
        children: [
          {
            path: "",
            name: "learner-certificate-home",
            component: () => import("@/views/learner/certificate/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "todo",
        component: () => import("@/views/learner/todo/"),
        children: [
          {
            path: "",
            name: "learner-todo-home",
            component: () => import("@/views/learner/todo/home"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "create",
            name: "learner-todo-create",
            component: () => import("@/views/learner/todo/create"),
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "edit/:id",
            name: "learner-todo-edit",
            component: () => import("@/views/learner/todo/edit"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "webinar",
        component: () => import("@/views/learner/webinar/index"),
        children: [
          {
            path: "",
            name: "learner-webinar",
            component: () => import("@/views/learner/webinar/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      {
        path: "gamification",
        component: () => import("@/views/learner/gamification/"),
        children: [
          {
            path: "",
            name: "learner-gamification-home",
            component: () => import("@/views/learner/gamification/home"),
            meta: {
              middleware: [auth],
            },
          },
        ],
      },
      // {
      //   path: "/learner/course/lesson/:lesson",
      //   name: "learner-new-single-lesson",
      //   component: () => import("@/views/learner/single-lesson"),

      // },
    ],
  },
];
